import React from 'react';
import { EmptyBox } from '@icons/common';
import styled from 'styled-components';

const EmptyTicketsList = () => (
  <StyledEmptyTicketsListWrapper>
    <StyledEmptyBox />
    <span>Список тикетов пуст. Попробуйте изменить параметры фильтрации</span>
  </StyledEmptyTicketsListWrapper>
);

const StyledEmptyTicketsListWrapper = styled.div`
  background: transparent;
  border-radius: 4px;
  border: 2px dashed #c0c2c4;
  height: 160px;
  width: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #4d4d4d;

  span {
    font-size: 16px;
    text-align: center;
    margin-top: 5px;
  }
`;

const StyledEmptyBox = styled(EmptyBox)`
  fill: #4d4d4d;
  width: 70px;
`;

export default EmptyTicketsList;
